import { render, staticRenderFns } from "./HowToEn.vue?vue&type=template&id=bbcf11aa&scoped=true&"
var script = {}
import style0 from "./HowToEn.vue?vue&type=style&index=0&id=bbcf11aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbcf11aa",
  null
  
)

export default component.exports